import { format } from "date-fns";
import { ObjectGeneric } from "../../../../../../../utils/types/generals";
import { Constants } from "../../../../../../../utils/constants";
import dayjs from "dayjs";

const formatUrlQueryFromFilters = (payload: ObjectGeneric) => {
    let url = ''
    delete payload.units
    const arr = Object.entries(payload)
    for (const [key, item] of arr) {
        if (item) {
            if (item instanceof Array) {
                url = `${key}=${item?.map(item => item.value || item).join(',')}&${url}`
            } else if (['to', 'from'].includes(key)) {
                url = `${key}=${format(dayjs(item).valueOf(), Constants.dateFormat)}&${url}`
            } else {
                url = `${key}=${item?.value || item}&${url}`
            }
        }
    }
    if (!payload?.intervale?.value) {
        url = `intervale=1d&${url}`
    }
    return { url: url.slice(0, -1) }
}

export { formatUrlQueryFromFilters }